import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  infoTagWrapper: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
  },
  infoTagSwitchWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'stretch',
    marginBottom: '20px',
  },
}));
